import React, { Component } from 'react';
import { isEmpty } from 'lodash';
import { Box, Grid, IconButton, List, ListItem, TableBody, TableCell, TableHead, TableRow, Typography } from '@material-ui/core';
import PopUp from '../../../../commonModules/interface/PopUp';
import SwipeableTabs from '../../../../commonModules/MUI/SwipeableTabs';
import { pink } from '@material-ui/core/colors';
import ProgressCircle from '../../../../commonModules/interface/ProgressCircle';
import { ListLayout, TableLayout } from '../containers/Layout';
import Currency from '../../../../commonModules/Currency';
import mime from 'mime';

import { CloudDownloadRounded } from '@material-ui/icons';

class SingleSaleCredits extends Component {
    state = { 
        historySale: [],
        history: [],
        clients: [],
        currentYear: "2021",
    }
    componentDidMount = () => {
        if ( isEmpty(this.props.SALE_CREDITS) ){
            this.props.fetchSaleCredits()
        }
    }
    filterList = () => {
        const { SALE_CREDITS } = this.props;
        console.log("[DEBUG],filterList",SALE_CREDITS)
        let list = !isEmpty(SALE_CREDITS) ? Object.values(SALE_CREDITS).filter( item => item.sale_id === this.props.sale.id) : []
        return list
    }

    render() {
        const { sale, client } = this.props;
        let list = this.filterList()
        let total = 0
        list.forEach(item => total += item.amount)
        console.log({list});

        console.log(this.state, this.props);
        return (
            <PopUp
                title={`${sale.nature} n°${sale.id}`}
                close={this.props.closePopUp}
            >
                {/* <SwipeableTabs
                    labels={["Ventes", "Clients"]}
                    default="Ventes" 
                > */}
                    <Grid container spacing={1} style={{ textAlign: "center"}}>
                        <Grid item xs={12} md={8} >
                            <Typography variant="h6">Liste des paiements à Crédit</Typography>
                            <ListLayout>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Date</TableCell>
                                        <TableCell>Ref</TableCell>
                                        <TableCell>Montant</TableCell>
                                        <TableCell>Documents</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    { list.map( item => 
                                    <TableRow>
                                        <TableCell>{new Date(item.date).toLocaleString("fr-FR")}</TableCell>
                                        <TableCell>{item.ref}</TableCell>
                                        <TableCell><Currency value={item.amount} /></TableCell>
                                        <TableCell>
                                            {!isEmpty(item.credit_files) &&
                                                <a href={`/stocks/photos/${item.credit_files[0].filename}`} 
                                                    download={`${client.client_lastname}_${item.ref}.${ mime.getExtension(item.credit_files[0].filetype) || "pdf"}`}
                                                >
                                                    <IconButton color="secondary" >
                                                        <CloudDownloadRounded />
                                                    </IconButton>      
                                                </a>
                                            }
                                        </TableCell>
                                    </TableRow>
                                    )}
                                </TableBody>
                            </ListLayout>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Typography variant="h6">Total des paiements</Typography>
                            <Box p={1}>
                                <ProgressCircle
                                    color={pink[200]} 
                                    spent={total} 
                                    max={sale.total_price} 
                                    value={total*100/sale.total_price} 
                                />
                            </Box>
                        </Grid>
                    </Grid>

                {/* </SwipeableTabs> */}
            </PopUp>
        );
    }
}

export default SingleSaleCredits;
